/** @type {((session: import('./PdfPrintPreviewModal').PdfPrintPreviewSession | null) => void) | null} */
let setPreviewSession = null;

/**
 * Called once from {@link PdfPrintPreviewHost} on mount.
 * @param {((session: import('./PdfPrintPreviewModal').PdfPrintPreviewSession | null) => void) | null} setter
 */
export function registerPdfPrintPreviewHost(setter) {
    setPreviewSession = setter;
}

/**
 * @typedef {Object} OpenPdfPrintPreviewOptions
 * @property {string} templateId
 * @property {Record<string, unknown>} props
 * @property {string} [title]
 */

/**
 * Opens the print preview modal. Resolves when the user prints; rejects if cancelled.
 * @param {OpenPdfPrintPreviewOptions} options
 * @returns {Promise<void>}
 */
export function openPdfPrintPreview(options) {
    return new Promise((resolve, reject) => {
        if (!setPreviewSession) {
            reject(new Error('Print preview is not ready. Reload the page and try again.'));
            return;
        }

        setPreviewSession({
            templateId: options.templateId,
            props: options.props,
            title: options.title || 'Print preview',
            onPrinted: () => {
                setPreviewSession(null);
                resolve();
            },
            onCancel: () => {
                setPreviewSession(null);
                reject(Object.assign(new Error('Print cancelled'), { code: 'PRINT_CANCELLED' }));
            },
        });
    });
}
